import React,{ useState, forwardRef, useImperativeHandle } from 'react';


const ApplicalbeDays = forwardRef((props: any, parentRef: any) => {

    const [valueList, setValueList] = useState<{ title: string, value: boolean }[]>(props.valueList)
    const [isClear, setIsClear] = useState<boolean>(props.isClear)
    const resetData = () => {
        const { originData } = props
        setValueList(originData)
    }
    useImperativeHandle(parentRef, () => {
        const refObj = {
            resetData: resetData,
            valueList: isClear ? null : valueList
        }
        return refObj
    })

    return (
        <div>
            <div style={{ fontSize: 12, color: '#999999', height: '24px', "fontWeight": 600 }}>{props.label}</div>
            <div style={{ display: 'flex', width: '100%' }}>
                {valueList.map(
                    (item: { title: string, value: boolean }, index: number) => (
                        <div style={{ flex: 1, 'userSelect': 'none' }} key={index}>
                            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10, color: '#333333' }}>{item.title}</div>
                            {
                                isClear ? <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', padding: '20 0' }}>
                                    {

                                        <div style={{ height: 40, lineHeight: '40px', width: '60%', margin: 'auto', cursor: 'pointer' }} onClick={() => {
                                            if (!props.readOnly) {
                                                props.setIsClear(false)
                                                setIsClear(false)
                                                let _valueList = JSON.parse(JSON.stringify(valueList))
                                                _valueList.map((item: any) => item.value = true)

                                                setValueList(_valueList)
                                                props.setValueListAfterChanged(_valueList)
                                            }
                                        }}>
                                            <span style={{ color: '#999999' }}>NA</span>
                                        </div>
                                    }
                                </div> : <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', padding: '20 0' }}>
                                    {
                                        props.readOnly ?
                                            <div style={{ height: 40, lineHeight: '40px', width: '60%', margin: 'auto', cursor: 'pointer' }}>
                                                {item.value ? <span className="blue-font">YES</span> : <span style={{ color: '#f07171' }}>NO</span>}
                                            </div> :
                                            <div style={{ height: 40, lineHeight: '40px', width: '60%', margin: 'auto', cursor: 'pointer' }} onClick={
                                                () => {
                                                    let _valueList = JSON.parse(JSON.stringify(valueList))
                                                    _valueList[index].value = !valueList[index].value
                                                    setValueList(_valueList)
                                                    props.setValueListAfterChanged(_valueList)
                                                }
                                            }>
                                                {item.value ? <span className="blue-font">YES</span> : <span style={{ color: '#f07171' }}>NO</span>}
                                            </div>
                                    }

                                </div>

                            }
                        </div>
                    )
                )}
            </div>

        </div>
    )
})

export default ApplicalbeDays;



